import Header from "./Header";
import CreateProject from "../Create";
import styled from 'styled-components';
import { MapModalTypes } from "constant";
import { useDispatch } from "react-redux";
import Accordion from "../../../Accordion";
import MapModal from "components/MapModal";
import TextButton from "components/TextButton";
import React, { useState, useEffect } from "react";
import AccordionItem from "../../../Accordion/AccordionItem";
import useViewerStore from '../../../../store-zustand/viewer';
import useProjectStore from '../../../../store-zustand/project';
import { BBOX_CENTROID, getBBOX } from '../../../MapView/MapUtils';

const ProjectsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 3.5rem;

  h2 {
    color: ${({ theme }) => theme.textColor.default};
  }

  button {
    color: #C4C4C4 !important;
    &:hover {
      color: white !important;
    }
  }
`;

const AllProjects = ({ project, handleSingleProject, onClose, returnAllProjectsPage }) => {
  const [mapModal, setMapModal] = useState(project);
  const [loadingTypes, setloadingTypes] = useState(undefined);
  const { setselectedCategory, setselectedCategoryPK, GetProjectTypeList, GetProjectListByType, DeleteProjectById, setproject_modal_information, setselectedCategoryColor, CheckIfUserExist, AddProject, setproject_id } = useProjectStore();
  const { viewer, setcurrentBBOX, setmapboxvisibility } = useViewerStore();
  const [loadingTypesArray, setloadingTypesArray] = useState([]);
  const [ProjectCount, SetProjectCount] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (window.hasOwnProperty('GlobalAnnotationEntities')) {
        window.GlobalAnnotationEntities.entities.removeAll();
      }

      if (loadingTypes !== undefined) return;
      const PROJECTSTypes = await GetProjectTypeList();
      if (PROJECTSTypes !== 'Error') {
        setloadingTypes(PROJECTSTypes);
        const twoDSwitcher = (info) => {
          alert(info);
        }
        await Promise.all(PROJECTSTypes.map(async ({ pk, fields }, index) => {
          const type = {
            IDTYPE: pk
          }
          const projects_list = await GetProjectListByType(type);
          if (ProjectCount == 0) {
            if (projects_list.length > 0) {
              SetProjectCount(1);
            }
          }

          setloadingTypesArray((prev) => [...prev,
          <Accordion key={index} heading={fields.TYPENAME} id={`accordion-${index}`} sort color={fields.COLOR}>
            {projects_list.map((item, index) => {
              return (
                <AccordionItem
                  menutype={'AllProject'}
                  bbox={item.fields.BBOX}
                  key={index}
                  keyword={item.pk}
                  label={(item.fields.NAME === null || item.fields.NAME === 'null') ? 'Untitled' : item.fields.NAME}
                  onClick={() => { handleSelectProject(item) }}
                  onEdit={() => {
                    handleSingleProject('index');
                  }
                  }
                  onDelete={() => { hanldeDeleteProject(item.pk) }}
                  twoDSwitcher={twoDSwitcher}
                />
              )
            })}
          </Accordion>]);
        }))
      }
      else {
        alert('Error while getting Type list');
      }
      if (!isMounted) return;
    })();

    return () => {
      isMounted = false; // cleanup
    };
  }, [loadingTypes]);

  const handleSelectProject = (obj) => {
    setMapModal({
      type: MapModalTypes.ProjectListSelected,
      title: "Area Name",
      address: obj.fields.ADDRESS,
      place_name: obj.fields.ADDRESS,
      region: obj.fields.REGION,
      country: obj.fields.COUNTRY,
      postal_code: obj.fields.POSTAL,
      city: `${obj.fields.ADDRESS}`,
      description: `${obj.fields.DESCRIPTION}`,
      temperature: `${obj.fields.TEMPERATURE}`,
      bbox: `${obj.fields.BBOX}`,
      projectid: `${obj.pk}`,
      typeId: `${obj.fields.type}`,
      projectname: `${obj.fields.NAME}`
    });

    dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });

    let location_string = `${obj.fields.ADDRESS}, ${obj.fields.REGION} ${obj.fields.POSTAL}, ${obj.fields.COUNTRY}`;
    if (location_string.length > 40) {
      location_string = location_string.substring(0, 37);
      location_string = `${location_string} ...`;
    }
    setproject_modal_information({
      info: {
        address: obj.fields.ADDRESS,
        place_name: obj.fields.ADDRESS,
        postal_code: obj.fields.POSTAL,
        region: obj.fields.REGION,
        country: obj.fields.COUNTRY,
        description: obj.fields.DESCRIPTION,
        temperature: obj.fields.TEMPERATURE,
        location: location_string,
        projectname: obj.fields.NAME
      }
    });

    let rect_arr = obj.fields.BBOX;
    let rect_string = rect_arr.replaceAll('[', '');
    rect_string = rect_string.replaceAll(']', '');
    rect_string = rect_string.replaceAll(`'`, '');
    let rect = rect_string.split(',');
    setcurrentBBOX(rect);
  };

  const handleEditProject = () => {
    handleSingleProject('index');
  };
  const AddNewBlanckProject = async () => {
    setselectedCategoryColor('#E5E5E5');
    const responseCheck = await CheckIfUserExist();
    const BBOX = getBBOX(viewer);
    const Centroid = BBOX_CENTROID(BBOX[0], BBOX[1], BBOX[2], BBOX[3]);

    let address = '  '
    let country = ''
    let region = 'Add address using search'
    let place = ''
    let postal_code = ''
    let USERID = localStorage.getItem('access_token');
    let TEMPERATURE = '--'
    const body_obj = {
      'postal_code': postal_code,
      'place': place,
      'region': region,
      'country': country,
      'address': address,
      'Centroid': Centroid,
      'BBOX': BBOX,
      'userID': USERID,
      'TEMPERATURE': TEMPERATURE
    }
    console.log("AddNewBlanckProject");
    const addproject_response = await AddProject(body_obj);
    console.log(addproject_response);
    if (addproject_response == 'error') {
      alert('An error occured while saving data');
    } else {
      dispatch({ type: 'TOGGLE_MAP_TOOL', show: true });
      dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: true });

      setproject_id(addproject_response);
      setselectedCategoryPK(responseCheck[0].pk);
      setselectedCategory(responseCheck[0].fields?.TYPENAME);
      setselectedCategoryColor(responseCheck[0].fields?.COLOR);

      setproject_modal_information({
        info: {
          address: '  ',
          place_name: '',
          postal_code: '',
          region: 'Add address using search',
          country: '',
          description: `${BBOX[0]}, ${BBOX[2]}`,
          temperature: '--',
          location: '',
          projectname: 'Untitled'
        }
      });

      handleSingleProject('direct-edit');

    }
  };

  const hanldeDeleteProject = async (param) => {
    const keywork = {
      PROJECTID: param
    }
    const response = await DeleteProjectById(keywork);
    if (response !== 'error') {
      alert('project was deleted');
      setloadingTypesArray([]);
      setloadingTypes(undefined);
    } else {
      alert('Error while deleting the project');
    }
  }

  useEffect(() => {
    if (mapModal) {
      dispatch({ type: 'TOGGLE_MAP_MODAL', show: true });
    } else {
      dispatch({ type: 'TOGGLE_MAP_MODAL', show: false });
    }
  }, [mapModal])

  if (loadingTypes == undefined) {
    return ('Loading Data...');
  }
  else if (loadingTypes.length == 0) {
    return <CreateProject handleCreateProject={AddNewBlanckProject} onClose={returnAllProjectsPage} />
  }
  else {

    if (ProjectCount == 0) {
      return <CreateProject handleCreateProject={AddNewBlanckProject} onClose={returnAllProjectsPage} />
    } else {
      return (
        <>
          <Header onClose={onClose} />
          <ProjectsHeader>
            <h2>Projects </h2>
            <TextButton text="ADD PROJECT" onClick={AddNewBlanckProject} />
          </ProjectsHeader>
          {loadingTypesArray}
          {mapModal && (
            <MapModal
              type={mapModal.type}
              info={mapModal}
              onChangeStatus={handleEditProject}
            />
          )}
        </>
      );
    }
  }
};

export default AllProjects;